import { LIVE_CHAT_DEFAULT_SETTINGS } from "@jugl-web/domain-resources/chat-bot/consts";
import { transformLiveChatAppSettingsToFormValues } from "@jugl-web/domain-resources/chat-bot/utils/transformLiveChatAppSettingsToFormValues";

export const INITIAL_FORM_VALUES = transformLiveChatAppSettingsToFormValues(
  LIVE_CHAT_DEFAULT_SETTINGS
);
